import { Header } from '@/components/Header';
import Config from '@/lib/config';
import { useMainContext } from '@/lib/context';
import {
  AutocompleteOption,
  DataLevel,
  LabelValue,
  MapSettings,
} from '@/lib/model';
import * as React from 'react';
import { Filters } from './Filters';
import './index.scss';
import { Map } from './Map';
import { Results } from './Results';
import { SearchBar } from './SearchBar';
import { SelectYear } from './SelectYear';

export interface MainComponentProps {
  mapSettings: MapSettings;
  filters: LabelValue<DataLevel>[];
  onOptionPress: (value: AutocompleteOption) => void;
  inputOptions: AutocompleteOption[];
}

export const MainComponent: React.FC<MainComponentProps> = ({
  mapSettings,
  filters,
  onOptionPress,
  inputOptions,
}) => {
  const {
    selectedYear,
    setSelectedYear,
    dataLevel,
    setDataLevel,
    isComuneLoading,
    handleResult,
    mainResult,
  } = useMainContext();

  // console.log( 'MAIN COMPONENT', {
  //   selectedYear,
  //   setSelectedYear,
  //   selectedRegion,
  //   setSelectedRegion,
  //   dataLevel,
  //   setDataLevel,
  //   isComuneLoading,
  //   results
  // })

  const onChangeDataLevel = (value: DataLevel) => {
    // Resetto tutti i dati
    if (value === DataLevel.COMUNE) {
      handleResult(mainResult!, true);
    }

    setDataLevel(value);
  };

  return (
    <div className="Main">
      <Header title={Config.headerTitle} />
      <div className="Main__Content">
        <div>
          {/*<Tabs<Region>*/}
          {/*  tabs={REGIONS}*/}
          {/*  value={selectedRegion}*/}
          {/*  onTabChange={setSelectedRegion}*/}
          {/*/>*/}
          <div className="Main__Content__Filters">
            <SearchBar
              options={inputOptions}
              onOptionPress={onOptionPress}
              isComuneLoading={isComuneLoading}
            />
            <SelectYear value={selectedYear} onYearChange={setSelectedYear} />
          </div>
        </div>
        <div className="Main__Content__RightPanel">
          <Filters
            filters={filters}
            value={dataLevel}
            onChange={onChangeDataLevel}
          />
          <Map {...mapSettings} />
        </div>
        <div>
          <Results />
        </div>
      </div>
    </div>
  );
};
